/**
 * Template types: users work with an agent to create/update templates for producing artifacts.
 */

import { z } from 'zod';

export const TemplateMetaSchema = z.object({
  templateId: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  /** e.g. summary_report, build_log */
  artifactType: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type TemplateMeta = z.infer<typeof TemplateMetaSchema>;
